var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 33.3333C60 51.8333 47.2 69.1333 30 73.3333C12.8 69.1333 0 51.8333 0 33.3333V13.3333L30 0L60 13.3333V33.3333ZM30 66.6667C42.5 63.3333 53.3333 48.4667 53.3333 34.0667V17.6667L30 7.26667L6.66667 17.6667V34.0667C6.66667 48.4667 17.5 63.3333 30 66.6667Z",
    fill: "#1FAF38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.a3593df3a5d1b6501fd8cf8bbd8c0629.svg";
export { ForwardRef as ReactComponent };